import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { addLayoutBacgkround } from 'PreviewActions/customLayoutActions';
import styled from 'styled-components';
import Dropzone from 'react-dropzone';
import { layoutBackgroundIcon } from 'Shared/assets/images/';

const DropzoneBackground = styled.div`
  position: absolute;
  width: 450px
  left: calc(50% - 225px);
  top: calc(50% - 125px);
  padding: 60px;
  text-align: center;
  background: rgba(200,200,200, 0.2);
  border-radius: 6px;
`;

const DropzoneIcon = styled.span`
  display: block;
  font-size: 50px;
`;

const DropzoneMessage = styled.span`
  display: block;
  margin-top: 16px;
  opacity: 0.6;
`;

const DropzoneSubMessage = styled.span`
  display: block;
  margin-top: 6px;
  opacity: 0.6;
  font-size: 85%;
`;

class LayoutBackgroundDropzone extends PureComponent {
  render() {
    const { addLayoutBacgkround } = this.props;
    return (
      <Dropzone
        ref={(node) => { this.dropzone = node; }}
        multiple={false}
        minSize={4}
        maxSize={52428800}
        preventDropOnDocument
        style={{ position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh' }}
        accept="image/*, video/*"
        onDrop={addLayoutBacgkround}
      >
        <DropzoneBackground>
          <DropzoneIcon>
            <img
              src={layoutBackgroundIcon}
              alt={'layout background file'}
              style={{
                width: '60px',
                height: 'auto',
                display: 'block',
                margin: 'auto',
              }}
            />
          </DropzoneIcon>
          <DropzoneMessage>Upload a background</DropzoneMessage>
          <DropzoneSubMessage>
            <div>Drag and drop layout background here or click to select file. For retina images, please add @2x to the filename.</div>
            <div>(i.e background@2x.png)</div>
          </DropzoneSubMessage>
        </DropzoneBackground>
      </Dropzone>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  addLayoutBacgkround: background =>
    dispatch(addLayoutBacgkround(background)),
});


export default connect(mapStateToProps, mapDispatchToProps)(LayoutBackgroundDropzone);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/LayoutBackgroundDropzone/LayoutBackgroundDropzone.jsx